import styles from './TooltipSeries.scss.js';
import { jsx } from 'react/jsx-runtime';

function TooltipSeries({
  children,
  isEmpty = false
}) {
  if (isEmpty) {
    return null;
  }

  return /*#__PURE__*/jsx("div", {
    className: styles.Series,
    children: children
  });
}

export { TooltipSeries };
